/**
 * Nómina → Documentos: plantillas y envíos en lote (PLAN_PLANTILLAS_DOCUMENTOS_RRHH).
 *
 * Va en Nómina y no en Configuración: generar el certificado de una
 * capacitación es trabajo del día a día de RR. HH., no un ajuste que se hace
 * una vez. La pestaña vive en la URL (`?tab=envios`) para que «volver» desde el
 * detalle de un envío aterrice donde estaba.
 */
import { useSearchParams } from 'react-router-dom'
import { SegmentGroup } from '@/components/ds/SegmentGroup'
import PlantillasTab from './PlantillasTab'
import EnviosTab from './EnviosTab'

type Pestana = 'plantillas' | 'envios'

export default function DocumentosPage() {
  const [params, setParams] = useSearchParams()
  const pestana: Pestana = params.get('tab') === 'envios' ? 'envios' : 'plantillas'

  return (
    <div className="space-y-4">
      <SegmentGroup<Pestana>
        label="Sección"
        value={pestana}
        onChange={(v) => setParams(v === 'plantillas' ? {} : { tab: v }, { replace: true })}
        options={[{ value: 'plantillas', label: 'Plantillas' }, { value: 'envios', label: 'Envíos' }]}
      />
      {pestana === 'plantillas' ? <PlantillasTab /> : <EnviosTab />}
    </div>
  )
}
